var _a;
import Constants from './constants';
var ResourcePrefix = (((_a = window.location) === null || _a === void 0 ? void 0 : _a.protocol) === 'http:' ? 'http:' : 'https:') + Constants.CDN_PREFIX_WITHOUT_PROTOCOL;
var _appendScript = function (srcUrl) {
    var $reportLayerJs = document.createElement('script');
    $reportLayerJs.src = srcUrl;
    $reportLayerJs.crossOrigin = 'anonymous';
    document.body.appendChild($reportLayerJs);
};
var _appendCss = function (cssUrl) {
    var $reportLayerCss = document.createElement('link');
    $reportLayerCss.rel = 'stylesheet';
    $reportLayerCss.type = 'text/css';
    $reportLayerCss.href = cssUrl;
    document.head.appendChild($reportLayerCss);
};
var showShakeLayer = function (reportTriggerAction) {
    var $loganShakeLayer = document.getElementById('loganShakeLayer');
    if (!$loganShakeLayer) {
        // loganShakeReportBtnAction is used in shake_layer.js
        window.loganShakeReportBtnAction = reportTriggerAction;
        _appendCss(ResourcePrefix + 'shake_layer.css');
        _appendScript(ResourcePrefix + 'shake_layer.js');
    }
    else {
        $loganShakeLayer.style.display = 'block';
    }
};
var hideShakeLayer = function () {
    var $loganShakeLayer = document.getElementById('loganShakeLayer');
    if ($loganShakeLayer) {
        $loganShakeLayer.style.display = 'none';
    }
};
var showReportLayer = function (reportAction) {
    var $loganReportLayer = document.getElementById('loganReportLayer');
    if (!$loganReportLayer) {
        // loganReportBtnAction is used in report_layer.js
        window.loganReportBtnAction = reportAction;
        _appendCss(ResourcePrefix + 'report_layer_2.css');
        _appendScript(ResourcePrefix + 'report_layer_2.js');
    }
    else {
        $loganReportLayer.style.display = 'block';
    }
};
export default {
    showShakeLayer: showShakeLayer,
    hideShakeLayer: hideShakeLayer,
    showReportLayer: showReportLayer
};
